<template>
    <div class="form-block">
        <div>
            <h2 class="form-block__title mb-3">{{prop_titleform}}</h2>
            <div class="form-block_body">
                <div class="black_block d-flex flex-column">                    
                    <h5 data-v-576aef83="">Choose category:</h5>                    
                    <div v-for="(category, idx) in categories" :key="idx" >
                         <category-card-list
                            :category="category"
                            :type='actionType'
                            :actionType="actionType"
                        ></category-card-list>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-block__footer d-flex justify-content-between">
            <div class="form-block__footer_left d-flex justify-content-start align-items-end">                
            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>                
                <button @click="movePerson" class="btn btn-primary">Move</button>
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from '../../bus';
import axios from "axios";
import CategoryCardList from "../Categories/CategoryCardList";

export default {
    props: [
        'prop_titleform', 
        'category_id', 
        'personsIds', 
        'crud',
        'categoryListType'
    ],
    data(){
        return{
            title_form: '',
            model_person: {
                faces: [],
                first_name: '',
                last_name: '',
                email: '',
                link: '',
                info: '',
                category_id: this.category_id
            },
            videos: [],
            faces: [],
            categories: [],
            model_find: '',
            left_person_id: '',
            new_category_id: '',
            actionType: 'move'
        }
    },
    methods: {
        findname(){
            console.log('this.model_find', this.model_find);
            this.getCategoriesWithPersons();

        },
        movePerson(){            
            
            const url = '/persons/move',
                data = {
                    'category_id': this.new_category_id,
                    'personsIds': this.personsIds
                };

             axios.post( 
                url,
                data,
                {
                    headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                }
            ).then((responce)=>{                
                console.log('Result merge', responce);                
                if(responce.data.success){
                    
                    console.log('Move success');
                    console.log('this.new_category_id', this.new_category_id);
                    
                    const new_person_id = responce.data.id_left_person;

                    this.mergeInProject();
                    
                    location.href=`/categories/${this.new_category_id}`;

                } else {
                    console.log('error merge');
                    console.log(responce.data);
                }                
            }).catch(function(e){
                console.log(e);
            });            
            this.closePopup();
        },
        mergeInProject(){
            //handover faces
            //del person
        },
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        getCategoriesWithPersons(){
            const url = '/categories/';
            
            const emptyWithHistories = false;
                        
            const params = {                
                additionalList: 'y',
                withoutEmpty: emptyWithHistories,
                find: this.model_find
            }
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'ContentType': 'application/json'
                    }
                }
            ).then((responce)=>{                
                this.data = responce.data;                
                this.categories = responce.data;
                console.log('this.categories', this.categories);
            }).catch(function(error){
                console.log(error);
            });
        }        
    },
    mounted(){
        this.title_form = this.prop_titleform;
        if(this.person){
            this.model_person = this.person;
        };
        this.getCategoriesWithPersons();
        bus.$on('changeCategoryMoveTo', (data) => {            
            
            this.new_category_id = data.new_category_id;

            console.log('this.new_category_id', this.new_category_id);

        })
    },
    components: {
        CategoryCardList
    },
    computed: {
        right_person_id(){
            return this.person.id;
        }
    }
    
}
</script>

<style scoped lang="scss">
    .input_search {
        margin-bottom: 10px;
    }
    .categoryName{
        cursor: pointer;
    }    
    .black_block{
        height: 500px;
        overflow-y: scroll;
    }
    .personMergeTo {        
        margin: 10px;
        input, label {
            cursor: pointer;
        }
    }
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
